// TODO: PERFORMANCE - getDistinctValues has O(n²) complexity due to nested find() operation. For large arrays, consider using Set for O(n) deduplication: return [...new Set(array)]
export const getDistinctValues = (array: any[]) =>
    array.reduce((list, element) => {
        if (!list.find((l) => l === element)) list.push(element);
        return list;
    }, []);

// TODO: NAMING-CONVENTION - Parameter name has typo: 'seperator' should be 'separator' for consistency with standard English spelling
export const getStringValue = (array: any[], seperator: string) =>
    array.reduce((string, value, i) => `${string}${value}${i < array.length - 1 ? `${seperator} ` : ''}`, '');

// TODO: LOGIC-ERROR - Hard-coded dates ('2023-02-01' and '2023-02-02') make this function brittle and year-dependent. The logic assumes times before 12:01 are next day, but this creates an arbitrary midnight crossing assumption. Should use a more robust time comparison approach or accept a reference date parameter.
export const sortTimeStrings = (array: string[]) =>
    array.sort((a, b) => {
        const aDate = a < '12:01' || a === '00:00' ? Date.parse(`2023-02-02 ${a}`) : Date.parse(`2023-02-01 ${a}`);
        const bDate = b < '12:01' || b === '00:00' ? Date.parse(`2023-02-02 ${b}`) : Date.parse(`2023-02-01 ${b}`);
        return aDate - bDate;
    });

export const compareArrays = (arr1: string[], arr2: string[]): boolean => {
    if (!arr1 || !arr2 || arr1.length < 1 || arr2.length < 1) return false;
    // TODO: FUNCTION-MUTATION - Function mutates input arrays by calling sort() which modifies arrays in-place. This causes unexpected side effects for callers. Should create copies: const arr1s = [...arr1].sort(); const arr2s = [...arr2].sort();
    const arr1s = arr1.sort();
    const arr2s = arr2.sort();
    return arr1s.length === arr2s.length && arr1s.every((e, index) => e === arr2s[index]);
};

// TODO: VALIDATION - Function doesn't validate that array items have the specified property or that property values are numeric. Missing properties return undefined, and undefined + number = NaN. Should add validation: if (typeof item[property] !== 'number') continue; or filter valid items first.
export const calculatePropertySum = (array: any[], property: string): number => array.reduce((sum, item) => sum + item[property], 0);
